import { inject, Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ResponsePopupComponent } from '../shared/components/response-popup/response-popup.component';

@Injectable({
  providedIn: 'root'
})
export class DialogMessageService {
  ref: DynamicDialogRef<ResponsePopupComponent> | null = null;

  private dialogService = inject(DialogService);

  showMessage(
    type: 'success' | 'warning' | 'error',
    header: string,
    message?: string,
    messageHtml?: string,
    onCloseCallback?: () => void,
    /** Dialog width override - detail views need more room than confirmations. */
    width?: string
  ) {
    const { icon, color } = this.iconFor(type);

    this.ref = this.dialogService.open(ResponsePopupComponent, {
      // PrimeNG renders `header` in its own title bar - without this the bar
      // shows only the close button and the title has nowhere to appear.
      header,
      width: width ?? '760px',
      breakpoints: { '960px': '90vw', '640px': '96vw' },
      contentStyle: { overflow: 'auto', maxHeight: '80vh', textAlign: 'left' },
      dismissableMask: true,
      data: { header, message, icon, color, messageHtml },
      closable: true,
    });
    this.ref?.onClose.subscribe(() => {
      if (onCloseCallback) {
        onCloseCallback();
      }
    });
  }

  private iconFor(type: 'success' | 'warning' | 'error'): { icon: string; color: string } {
    switch (type) {
      case 'success':
        return { icon: 'pi pi-check-circle', color: '#4caf50' };
      case 'error':
        return { icon: 'pi pi-times-circle', color: '#f44336' };
      case 'warning':
        return { icon: 'pi pi-exclamation-triangle', color: '#ff9800' };
    }
  }
}